import { buildApiUrl } from '@/global';

export async function rawLogoff() {
  try {
    const response = await fetch(buildApiUrl('/Cuenta/logoff'), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();

    if (result?.data.status === true) {
      localStorage.clear();
      window.location.href = '/login';
    } else {
      console.warn('Logoff fallido:', result?.data.message);
    }
  } catch (err) {
    console.error('Error during rawLogoff:', err);
  }

  //Forzado de eliminación y logoff
  localStorage.clear();
  window.location.href = '/login';
}
